module.exports = { maxWidth: 660, maxHeight: 490, x: 0, y: 0 }
